import { ModuleSize } from '@movecloser/page-builder/lib/contracts'
import { ModuleBase, ModuleFactory } from '../../contexts'
import { AvailableModuleDriver } from '../allowed'
import { getDefaultModuleAlignment, abstractModuleFactory } from '../abstract/form'
import { IframeModule, IframeModuleContent } from './Iframe.contracts'

export const iframeContentFactory = (): IframeModuleContent => ({
  html: '',
  src: '',
  height: '',
})

export const iframeFactory: ModuleFactory<IframeModule> = {
  ...abstractModuleFactory,

  createInitialSize (): ModuleSize {
    return {
      colSpan: 6,
      isResizable: true,
      maxColSpan: 12,
      maxRowSpan: 12,
      minColSpan: 1,
      minRowSpan: 1,
      rowSpan: 1
    }
  },

  createModule (): ModuleBase<IframeModule> {
    return {
      alignment: getDefaultModuleAlignment(),
      content: iframeContentFactory(),
      driver: AvailableModuleDriver.Iframe
    }
  }
}
